import { render, staticRenderFns } from "./cache_manager.vue?vue&type=template&id=15ff11ef&"
import script from "./cache_manager.vue?vue&type=script&lang=js&"
export * from "./cache_manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports